module.exports = __webpack_public_path__ + "static/media/Alert.fd557f41.svg";